<template lang="pug">
div(id="the_canvas_element_id")
  b-row
    b-col.order-md-2(md="4")
      b-card
        b-button(variant="primary", block, @click="changeCategModal()") Crear categoría de etiquetas
        hr
        .text-help
          alert-circle-icon.icon-md.mr-1
          span Las categorías te permiten agrupar etiquetas para un mejor control y visualización de éstas.
    b-col(md="8")
      empty-message(v-if="!categories.length", message="No hay categorías creadas")
      b-card.card-inactive(v-for="category in parsedCategories", :key="category.tag_category_id")
        b-row.pointer(v-b-toggle="'section_' + category.tag_category_id" @click="toggleCategory(category)")
          b-col.d-flex.align-items-center
            h5.mb-0.uppercase.mr-4 {{category.name}}
            edit-3-icon.icon-md.hover-primary.mr-3.text-secondary(v-b-tooltip.hover="'Editar categoría'", v-if="category.tag_category_id", @click.stop="changeCategModal(category)")
            trash-2-icon.icon-md.hover-danger.text-secondary(v-b-tooltip.hover="'Eliminar categoría'", v-if="category.tag_category_id", @click.stop="deleteCategory(category)")
          b-col(cols="auto")
            chevron-down-icon.collapse-icon(v-if="category.open")
            chevron-up-icon.collapse-icon(v-else)
        b-collapse.mt-3(:id="'section_' + category.tag_category_id")
          b-card.card-inactive
            b-row.pointer(v-b-toggle="'groups_' + category.tag_category_id" @click="category.groupsOpen=!category.groupsOpen")
              b-col.d-flex.align-items-center
                h5.mb-0 Grupos asociados
              b-col(cols="auto")
                plus-icon.icon-md.hover-primary.mr-3.text-secondary(v-b-tooltip.hover="'Agregar grupo'" @click.stop="addGroupModal.show=true")
                chevron-down-icon.collapse-icon(v-if=" category.groupsOpen ")
                chevron-up-icon.collapse-icon(v-else)
            b-collapse.mt-3(:id="'groups_' + category.tag_category_id")
              b-container.d-flex.justify-content-start.align-items-start.flex-wrap
                b-badge.mr-2.pointer.group-badge(variant="info" pill v-for="group in category.Groups", :key="group.group_id" @click="updateTagGroup(group.group_id,'remove')" @mouseover="hoverEffect" @mouseleave="leaveEffect" v-b-tooltip="'Eliminar grupo'") {{group.name}}
          b-card.mb-0(no-body)
            template(slot="header")
              b-row.align-items-center(no-gutters)
                b-col
                  p.mb-0 {{category.tag_category_id ? 'Etiquetas de categoría' : 'Etiquetas sin categoría'}}
                b-col(cols="auto")
                  b-button(variant="primary", size="sm", block, v-if="category.tag_category_id", @click="changeTagModal('create', category.tag_category_id)") Crear etiqueta
            b-table.card-table.table-nowrap.mb-0(:items="category.tags", :fields="tag_fields", responsive, show-empty, hover, @row-clicked="changeTagModal('update', $event)")
              template(v-slot:cell(name)="data")
                b-link.text-dark(@click="changeTagModal('update', data.item)") {{ data.item.name }}
              template(v-slot:cell(color)="{ item }")
                b-img.border(style="width:20px;height:20px;", :blank-color="item.color || '#6e84a3'", blank, rounded="circle", @click="changeTagModal('update', item)")
              template(v-slot:empty)
                p.text-help.mb-0 No hay etiquetas para esta categoría

  b-modal(v-model="tag_modal.show", centered, :title="tag_modal.title", cancel-title="Cancelar", :ok-title="tag_modal.ok_title", :ok-variant="tag_modal.ok_variant", @ok="tag_modal.action")
    b-container(fluid)
      label Nombre:
      b-form-input.mb-2(v-model="tag_data.name" placeholder="Nombre", trim, :state="tag_data.name ? null : (tag_data.validated ? false : null)")
      label Categoría:
      b-form-select.mb-2(v-model="tag_data.tag_category_id")
        option(:value="null" disabled) Selecciona categoría...
        option(v-for="tag_cat in tag_categories", :key="tag_cat.tag_category_id" :value="tag_cat.tag_category_id") {{tag_cat.name}}
      label Color:
      color-picker(:value="tag_data.color || '#6e84a3'", @input="tag_data.color = $event.hex")
      b-card.bg-light.text-center.text-sm.mb-0.mt-4(v-if="tag_modal.ok_title == 'Actualizar'")
        alert-triangle-icon.icon-sm.mr-2
        span Eliminar etiqueta no se puede deshacer.
        p.mb-0.mt-2
          b-link.text-danger(@click="deleteTag(tag_data)") Eliminar etiqueta

  b-modal(v-model="categ_modal.show", centered, :title="categ_modal.title", cancel-title="Cancelar", :ok-title="categ_modal.ok_title", :ok-variant="categ_modal.ok_variant", @ok="categ_modal.action")
    b-container(fluid)
      label Nombre:
      b-form-input.mb-2(v-model="category_data.name" placeholder="Nombre", trim, :state="category_data.name ? null : (category_data.validated ? false : null)")
  b-modal(v-model="addGroupModal.show", centered, :title="addGroupModal.title", cancel-title="Cancelar", :ok-title="addGroupModal.ok_title", :ok-variant="addGroupModal.ok_variant" @ok="updateTagGroup(addGroupModal.group_id)" :ok-disabled="filterGroups(current_category||{}).length == 0")
    b-container
      b-form-group(label="Nombre del grupo")
        b-select(v-model="addGroupModal.group_id")
          option(:value="null" disabled) Seleccionar grupo...
          option(v-for="group in filterGroups(current_category||{})", :key="group.group_id", :value="group.group_id") {{group.name}}
</template>

<script>
import { createNamespacedHelpers, mapActions } from "vuex";
import { Chrome } from "vue-color";

const tagController = createNamespacedHelpers("tag");
const tagCategoryController = createNamespacedHelpers("tag_category");

export default {
  data() {
    return {
      tag_data: {
        name: "",
        tag_category_id: "",
        color: "#6e84a3",
        validated: false,
      },
      tag_modal: {
        show: false,
        title: "Crear nueva etiqueta",
        ok_title: "Crear",
        action: this.createTag,
        ok_variant: "success",
      },
      tag_fields: [
        {
          key: "name",
          label: "Etiqueta",
        },
        {
          key: "color",
          label: "Color",
        },
      ],
      category_data: {
        name: "",
        validated: false,
      },
      categ_modal: {
        show: false,
        title: "Crear nueva categoría",
        ok_title: "Crear",
        action: this.createCategory,
        ok_variant: "success",
      },
      addGroupModal: {
        show: false,
        title: "Agregar grupo",
        ok_title: "Agregar",
        ok_variant: "success",
        group_id: null,
      },
      groups: [],
      current_category: null,
    };
  },
  computed: {
    ...tagController.mapState({
      tags: (state) => state.tags,
    }),
    ...tagCategoryController.mapState({
      tag_categories: (state) => state.tag_categories,
    }),
    categories() {
      const general = {
        tag_category_id: 0,
        name: "Otras",
        tags: this.tags.filter((t) => !t.tag_category_id),
      };
      const all_categories = this.tag_categories.map((c) => {
        c.tags = this.tags.filter(
          (t) => t.tag_category_id == c.tag_category_id
        );
        return c;
      });

      if (general.tags.length) {
        all_categories.push(general);
      }

      return all_categories;
    },
    parsedCategories() {
      return this.categories.map(category=>({...category, groupsOpen:false}))
    },
  },
  methods: {
    ...mapActions([
      "tag/all",
      "tag/create",
      "tag/update",
      "tag/destroy",
      "tag_category/all",
      "tag_category/create",
      "tag_category/update",
      "tag_category/destroy",
      "tag_category/tagGroup",
      "group/all",
    ]),    
    filterGroups({ Groups=[] }={Groups:[]}) {
      return this.groups.filter(
        (g) => !Groups.find((cg) => cg.group_id == g.group_id)
      );
    },
    getCategories() {
      let self = this;

      this["tag_category/all"]({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error);
          }
        },
      });
    },
    createCategory(bvModalEvt) {
      if (!this.category_data.name) {
        bvModalEvt.preventDefault();
        this.category_data.validated = true;
        return;
      }

      var self = this;
      this["tag_category/create"]({
        account_id: self.$route.params.account_id,
        ...self.category_data,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error);
          }
        },
      });
    },
    updateCategory(bvModalEvt) {
      if (!this.category_data.name) {
        bvModalEvt.preventDefault();
        this.category_data.validated = true;
        return;
      }

      var self = this;
      this["tag_category/update"]({
        ...self.category_data,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error);
          }
        },
      });
    },
    async deleteCategory(tag_category) {
      var self = this;
      try {
        let response = await this.$bvModal.msgBoxConfirm(
          `¿Deseas eliminar esta categoría? No se puede deshacer.`,
          {
            title: "Eliminar categoría",
            okVariant: "danger",
            okTitle: "Eliminar",
            cancelTitle: "Cancelar",
          }
        );
        if (response) {
          this["tag_category/destroy"]({
            ...tag_category,
            callback: (res) => {
              if (res.error) {
                self.$message.error(res.error);
              }
            },
          });
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    getTags() {
      let self = this;
      // this.showLoadingScreen()

      this["tag/all"]({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          self.hideLoadingScreen();
          if (res.error) {
            self.$message.error(res.error);
          }
        },
      });
    },
    createTag(bvModalEvt) {
      if (!this.tag_data.name) {
        bvModalEvt.preventDefault()

        return this.tag_data.validated = true
      }

      this["tag/create"]({
        account_id: this.$route.params.account_id,
        ...this.tag_data,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)

          this.clearTagData()
        },
      });
    },
    updateTag(bvModalEvt) {
      if (!this.tag_data.name) {
        bvModalEvt.preventDefault()

        return this.tag_data.validated = true
      }

      this["tag/update"]({
        ...this.tag_data,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error);

          this.clearTagData()
        },
      });
    },
    async deleteTag(tag) {
      try {
        let response = await this.$bvModal.msgBoxConfirm(
          `¿Deseas eliminar este grupo? No se puede deshacer.`,
          {
            title: "Eliminar grupo",
            okVariant: "danger",
            okTitle: "Eliminar",
            cancelTitle: "Cancelar",
          }
        );
        if (response) {
          this["tag/destroy"]({
            ...tag,
            callback: (res) => {
              if (res.error) return self.$message.error(res.error)
              
              this.clearTagData()
              this.tag_modal.show = false
            },
          });
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    changeTagModal(action, tagCategoryId) {
      this.clearTagData()

      if (action == "update") {
        this.tag_data = Object.assign(this.tag_data, tagCategoryId)
        this.tag_modal.title = "Actualizar etiqueta"
        this.tag_modal.ok_title = "Actualizar"
        this.tag_modal.ok_variant = "primary"
        this.tag_modal.action = this.updateTag
      }

      if (action == "create") {
        this.tag_data.tag_category_id = tagCategoryId
  
        this.tag_modal.title = "Crear nueva etiqueta"
        this.tag_modal.ok_title = "Crear"
        this.tag_modal.ok_variant = "success"
        this.tag_modal.action = this.createTag
      }
      
      this.tag_modal.show = true;
    },
    changeCategModal(category) {
      this.clearObject(this.category_data);
      
      if (category) {
        this.category_data = Object.assign(this.category_data, category);
        this.categ_modal.title = "Actualizar categoría";
        this.categ_modal.ok_title = "Actualizar";
        this.categ_modal.ok_variant = "primary";
        this.categ_modal.action = this.updateCategory;
      } else {
        this.categ_modal.title = "Crear nueva categoría";
        this.categ_modal.ok_title = "Crear";
        this.categ_modal.ok_variant = "success";
        this.categ_modal.action = this.createCategory;
      }
      this.categ_modal.show = true;
    },
    clearTagData() {
      this.tag_data = {
        name: '',
        tag_category_id: '',
        color: '',
        validated: false,
      }
    },
    toggleCategory(category) {
      category.open = !category.open;
      this.current_category = category;
    },
    updateTagGroup(groupId, mode = "add") {
      const body = {
        mode,
        groups: [groupId],
      };
      this["tag_category/tagGroup"]({
        tagGroup: this.current_category.tag_category_id,
        body,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error);
          const category = this.categories.find(
            (c) => c.tag_category_id == this.current_category.tag_category_id
          );
          category.Groups = res.Groups;
          this.current_category = category;
          if(mode === 'remove') return this.$message.success('Grupo eliminado');
          this.$message.success('Grupo agregado');
          this.addGroupModal.group_id = null;
        },
      });
    },
    getGroups() {
      this["group/all"]({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error);
          this.groups = res.resource;
        },
      });
    },
    hoverEffect(e) {
      e.preventDefault();
      const el = e.target;
      el.classList.add("badge-danger");
      el.classList.remove("badge-primary");
    },
    leaveEffect(e) {
      e.preventDefault();
      const el = e.target;
      el.classList.add("badge-primary");
      el.classList.remove("badge-danger");
    }
  },
  mounted() {
    this.getCategories();
    this.getTags();
    this.getGroups();
  },
  components: {
    "color-picker": Chrome,
  },
};
</script>

<style lang="css" scoped>
.collapse-icon {
  transition: 0.3s;
}

.upsidedown {
  transform: rotate(-180deg);
}
</style>
